import React from "react";
import Alert from "@mui/material/Alert";
import LoadingSpinner from "./LoadingSpinner";

function DataView({ loading, error, data, loadingMessage, children }) {
  if (loading) return <LoadingSpinner message={loadingMessage} />;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!data) return null;
  return children;
}

export default DataView;
